import React from 'react'
import Navbar from '../../../Components/Navbar/Navbar'

const EssenceHead = () => {
  return (
    <div>
      <div className="container-fluild overflow-hidden position-relative">
        <section className="nebopan">
          <div
            className="nebopan-banner-section position-relative"
            style={{
              backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("/assets/images/maxresdefault-5.png")',
            }}
          >
            
          </div>
          {/* Text inside the background */}
          <div className="position-absolute top-50 start-50 translate-middle text-center text-white">
            <p className="m-0 centered-p">Je choisis mon essence de bois</p>
          </div>
        </section>
      </div>

      <div>
        <Navbar />
      </div>


    </div>
  )
}

export default EssenceHead